import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

import type { IRole } from '../../types/IComponentTypes';
import type { IDeleteRequest } from '../../types/IApiTypes';

export const RoleApi = {
  getRoles: (action: { page: number; limit: number; searchCode?: string }, dispatch: Dispatch) => {
    let queryParams = new URLSearchParams();
    if (action.page && action.limit) {
      queryParams = new URLSearchParams({
        [EUrlParams.Page]: String(action.page),
        [EUrlParams.Limit]: String(action.limit),
      });
    }

    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }

    return AxiosClient.post('/role/v1/read' + (queryParams ? `?${queryParams}` : ''), [])
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.RoleKey
        );
      });
  },

  createRole: (action: { request: IRole }, dispatch: Dispatch) => {
    return AxiosClient.post('/role/v1/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  updateRole: (action: { request: IRole }, dispatch: Dispatch) => {
    return AxiosClient.post('/role/v1/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  deleteRoles: (action: IDeleteRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/role/v1/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getRoleDetails: (action: { request: any }, dispatch: Dispatch) => {
    return AxiosClient.post('/role/v1/read', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },
};
